/**
 * sun-quantity-picker.js — Web Component <sun-quantity-picker>
 *
 * Single/Pair toggle that syncs to the product form's hidden quantity input
 * and mirrors the Add-to-cart button's disabled state.
 *
 * Scope: rendered inside sections/sun-product.liquid. Loaded from there.
 */
if (!customElements.get('sun-quantity-picker')) {
  class SunQuantityPicker extends HTMLElement {
    connectedCallback() {
      this.radios = this.querySelectorAll('input[data-qty-value]');
      this.quantityInput = this.getQuantityInput();

      this.handleChange = this.handleChange.bind(this);
      this.radios.forEach((radio) => {
        radio.addEventListener('change', this.handleChange);
      });

      this.observeAddToCart();
    }

    disconnectedCallback() {
      if (this.observer) this.observer.disconnect();
      if (this.panelObserver) this.panelObserver.disconnect();
      this.radios.forEach((radio) => {
        radio.removeEventListener('change', this.handleChange);
      });
    }

    getQuantityInput() {
      const sectionId = this.dataset.sectionId;
      const form = document.getElementById(`product-form-${sectionId}`);
      if (form) {
        return form.querySelector('input[name="quantity"]');
      }
      const section = document.getElementById(`SunProduct--${sectionId}`);
      if (section) {
        return section.querySelector('input[name="quantity"]');
      }
      return null;
    }

    handleChange(event) {
      const qty = parseInt(event.currentTarget.value, 10);

      if (this.quantityInput) {
        this.quantityInput.value = qty;
        this.quantityInput.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }

    observeAddToCart() {
      const sectionId = this.dataset.sectionId;
      const section = document.getElementById(`SunProduct--${sectionId}`);
      if (!section) return;

      const atcButton = section.querySelector('[name="add"]');
      if (!atcButton) return;

      const panel = this.closest('.sun-product__panel');

      const sync = () => {
        const isSoldout = panel && panel.classList.contains('variant--soldout');
        this.radios.forEach((radio) => {
          radio.disabled = atcButton.disabled && !isSoldout;
        });
      };

      sync();

      this.observer = new MutationObserver(sync);
      this.observer.observe(atcButton, { attributes: true, attributeFilter: ['disabled'] });

      if (panel) {
        this.panelObserver = new MutationObserver(sync);
        this.panelObserver.observe(panel, { attributes: true, attributeFilter: ['class'] });
      }
    }
  }

  customElements.define('sun-quantity-picker', SunQuantityPicker);
}
